export enum PlatformContentType {
    RaiseRight = 'RaiseRight',
    FlipGive = 'FlipGive',
}
